var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 39.55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.11,
    cy: 13.52,
    rx: 5.03,
    ry: 12.89,
    transform: "matrix(.97 -.26 .26 .97 -2.3 9.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.29 26-1.45-.29a53.26 53.26 0 0 0 -24.47.73l-3 .81a3.14 3.14 0 0 1 -3.89-2.25l-1.63-6.09a3.15 3.15 0 0 1 2.23-3.85l3-.82a53.25 53.25 0 0 0 21.59-11.6l1.11-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.79 18.92c-1.68.45-2.07 2-1.62 3.69s1.57 2.84 3.25 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.89 25.57 2 9.8a1.23 1.23 0 0 1 -.24 1l-1.23 1.63a1.26 1.26 0 0 1 -.89.48l-1 .08a2.52 2.52 0 0 1 -2.53-1.75l-3.12-9.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.43 26.1 2.65 12.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.82 25.23a17 17 0 0 1 -2.82-6.05 16.79 16.79 0 0 1 -.57-6.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.37 24.9a17.84 17.84 0 0 1 -3-6.37 17.79 17.79 0 0 1 -.6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.75 19c2.37-.64 2.92-2.84 2.29-5.21s-2.22-4-4.59-3.37"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaign);
export default __webpack_public_path__ + "static/media/icon_campaign.025a7caf46bbcc6a74d553a56348211c.svg";
export { ForwardRef as ReactComponent };